import * as ActionTypes from '../constants';
import { baseUrl } from './index';
import AsyncStorage from '@react-native-community/async-storage';
import axios from 'axios';
import { getUserToken } from './getUserToken';


const dispatchRequestTest = test => ({
    type: ActionTypes.REQUEST_TEST,
    requestedTestId: test   
})

const dispatchReceviedTest = (test, duration, test_id, data, passages) => ({
    type: ActionTypes.RECEIVED_TEST,
    test,
    duration,
    testId: test_id,
    data,
    passages
})

const dispatchErrorTest = (e) => ({
    type: ActionTypes.ERROR_TEST,
    error:e
})

const dispatchSelectedAnswers = (ans, qi) => ({
    type: ActionTypes.SELECTED_ANSWERS,
    answer: ans,
    quistionsInfo: qi
})

const dispatchMarkedQuestions = questions => ({
    type: ActionTypes.MARKED_QUESTION,
    questions
})

const dispatchChangeQuestion = qNo => ({
    type: ActionTypes.CHANGE_QUESTION,
    qustionsNo:qNo
})

const dispatchClearTest = () => ({
    type: ActionTypes.CLEAR_TEST,    
})

export const clearTest = () => dispatchClearTest();

export function changeQuestion(qNo) {
    return (dispatch, getState) => {
        let totalQuestions = getState().testInfo.test.length;
        if(qNo < 0 || qNo >=totalQuestions) return null;        
        dispatch(dispatchChangeQuestion(qNo));
    }
}

export function selectedAnswers(qId, answer) { 
 
    return (dispatch, getState) => {       
        let answers = getState().testInfo.selectedAnswers || [];
        
        let index;
        answers.map(x => {
            if(x.id === qId) {
                index = answers.indexOf(x);
            }           
        })
        if(index>=0) {
            answers[index].answer_option = answer;
        }else{
            answers = [...answers, {id: qId, answer_option: answer, status: 1}];            
        } 
        return dispatch(dispatchSelectedAnswers(answers));       
    }
}

export function getTest(testId, isPlannedTest, isTestSeries) {
    let endPoint = isPlannedTest ? "start_planned_test" : isTestSeries ? 'start_mock_test' : 'start_test';
    let data = isPlannedTest ? { event_id : testId} : isTestSeries ? { mock_test_id : testId } : { test_id : testId }

    // alert(JSON.stringify(isPlannedTest));

    // console.log(testId, isPlannedTest, endPoint, data);
    return dispatch => {
        dispatch(dispatchRequestTest(data));

        getUserToken().then(token => {           
           return axios({
                method: 'POST',
                url: `${baseUrl}/api/${endPoint}`,
                data,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })          
            .then(({data}) => {  
                if(data) {   
                    // console.log(data,'test data');                
                    const { questions, duration = 12, test_id = null, passages} = data;              
                    if(questions && duration) {
                        dispatch(dispatchReceviedTest(questions, duration, test_id, data, passages));
                    }else{
                        dispatch(dispatchErrorTest({message: 'something went wrong...'}))
                    }
                }else{
                    dispatch(dispatchErrorTest({message: 'something went wrong...'}))
                }
            })
        })
        .catch(e => {
            dispatch(dispatchErrorTest(e));
        })
    }
}

export function markedQuestions(qId) {
 
    return (dispatch, getState) => {
        let markedQustions = getState().testInfo.questionsInfo || [];
        let index;

        markedQustions.map(q => {            
            if(q.id === qId) {
                return index = markedQustions.indexOf(q);
            }
        })

        if(index>=0) {
            markedQustions[index].marked=!markedQustions[index].marked;
        }else{
            markedQustions = [...markedQustions, {id:qId, marked:true}]
        }
        dispatch(dispatchMarkedQuestions(markedQustions));
    }
}




























// const dispatchRequestStartTest = test => ({
//     type: ActionTypes.REQUEST_START_TEST,
//     test
// })

// const dispatchReceivedStartTest = res => ({
//     type: ActionTypes.RECEIVED_START_TEST,
//     res
// })

// const dispatchErrorStartTest = err => ({
//     type: ActionTypes.ERROR_START_TEST,
//     err
// })

// export const dispatchClearStartTest = () => ({
//     type: ActionTypes.CLEAR_START_TEST
// })

// export function startTest(testId) {
//     return dispatch => {

//         dispatch(dispatchRequestStartTest(testId));

//         getUserToken().then(token => {
//             const data = {
//                 test_id : testId
//             }
//            return axios({
//                 method: 'POST',
//                 url: `${baseUrl}/api/start_test`,
//                 data,
//                 headers: {
//                     'Authorization': `Bearer ${token}`
//                 }
//             })          
//             .then(({data}) => {
//                 dispatch(dispatchReceivedStartTest(data));
//             })
//         })
//         .catch(e => {
//             dispatch(dispatchErrorStartTest(e.response));
//         })
            
//     }

// }

